module.exports = "/_next/static/images/OneApi-d337e16bb75c12a9ded30309bc5352a6.webp";